module.exports = {
    title: '中鼎誉润智慧云OA',
    logo: './images/logo.png',
    loginType: 'ProductPanel', //  可选值   RightPanel || TechPanel || PortalPanel || PlatPanel  || ProductPanel || oldLogin  选不同页面
    headerbgColor: '',
    fullScreen: false, // 流程和新开窗口表单是否全屏
    listDataBorder: true, // 列表边框线样式

    /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
    showSettings: false,

    /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
    tagsView: true,

    /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
    fixedHeader: false,

    /**
   * @type {boolean} true | false
   * @description Whether show the showTopMenus
   */
    showTopMenus: true,

    /**
   * @type {boolean} true | false
   * @description Whether need stripeTable
   */
    stripeTable: false, // 表格交替色

    addStyle: true, // 皮肤

    saveNoValidation: true, // 保存不验证

    websocketAutoConnection: true // websocket自动连接
}
